/**
 * `Soggy Walrus`: an adjective, then a noun.
 *
 * The widest of the shapes, and the one that carries the roll: thirty by thirty is nine hundred
 * names, so two people in a four-seat lobby colliding is a curiosity rather than a routine.
 */

import { ABSURD_NOUNS } from '@/identity/nameWords/absurdNouns';
import { SILLY_ADJECTIVES } from '@/identity/nameWords/sillyAdjectives';
import type { NamePattern, WordPicker } from '@/identity/playerNameContract';

export const ADJECTIVE_NOUN: NamePattern = {
  id: 'adjectiveNoun',
  build(pick: WordPicker): string {
    return `${pick(SILLY_ADJECTIVES)} ${pick(ABSURD_NOUNS)}`;
  },
};
